import { Box } from "@mui/material";
import { H1 } from "../components/Typography";
import { FC } from "react";

// component props interface
interface TopBannerProps {
  imageLink: string;
  leftImageLink: string;
}

const TopBanner: FC<TopBannerProps> = ({ imageLink, leftImageLink }) => {
  return (
    <Box
      sx={{
        borderRadius: 5,
        display: {
          md: "flex",
          xs: "none",
        },
        justifyContent: "space-around",
        alignItems: "center",
        background: "linear-gradient(#00B4DB 0%,#0083B0 100%)",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
        },
        mt: 2,
      }}
    >
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "50%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "22%",
          },
          ml: 1,
        }}
        src={leftImageLink}
        alt="saas-dasboard-footer"
      />

      <Box
        justifyContent="center"
        textAlign="center"
        display="flex"
        sx={{
          width: {
            xs: "80%",
            sm: "80%",
            md: "50%",
          },
          paddingY: {
            xs: 2,
            sm: 2,
            md: 5,
          },
        }}
      >
        <H1
          fontSize={24}
          fontWeight={400}
          sx={{
            textAlign: "center",
            fontFamily: "'Poppins', sans-serif",
          }}
          color={"#fff"}
        >
          Grow your <span style={{ fontWeight: "bold" }}>wealth</span> with ease
          through our diversified
          <span style={{ fontWeight: "bold" }}> investment options</span>
        </H1>
      </Box>
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "80%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "24%",
          },
        }}
        src={imageLink}
        alt="saas-dasboard-footer"
      />
    </Box>
  );
};

export default TopBanner;
